<template>
    <new-vuestic-modal ref="presenca" v-bind:small="false" :cancelClass="'none'" okClass="none">
        <div slot="title">Registre sua presença</div>
        <div slot="body">
            <div class="container">
                <div class="row">
                    <video class="col-6 webCam" autoplay="true" id="webCamera"></video>
                    <img class="col-6 img-canvas" id="self"/>
                </div>
            </div>
        </div>
        <div slot="footer">
            <button type="button" class="btn-primary btnmodal" @click="self()"><i class="fa fa-camera"></i>Capturar</button>
            <button type="button" class="btn-primary btnmodal" @click="registerFrequency" :disabled="loading"><i class="fa fa-id-card">
                </i> Registrar {{ btnPresenca.text }}
            </button>
        </div>
    </new-vuestic-modal>
</template>
<script>
import urlApi from '../../../router/urlApi'

export default {
    name: 'modal-fotos',
    data: () => {
        return {
            btnPresenca: { text: '', load: false },
            agrupamento: '',
            loading: false,
        }
    },
    mounted () {
        this.agrupamento =  JSON.parse(sessionStorage.getItem('agrupamento'));
        // modal de presenças
        setInterval(() => {
            if(this.setIntervalo(this.agrupamento) && sessionStorage.getItem('intervalo') == 'false')
            {
                window.sessionStorage['intervalo'] = false;
                this.clearPhoto();
                this.btnPresenca.text = 'INTERVALO'
                this.loadCamera();
                this.$refs.presenca.open('');
            }
            if(this.setExit(this.agrupamento.data_fim) && sessionStorage.getItem('saida') == 'false')
            {
                window.sessionStorage['saida'] = false;
                this.clearPhoto();
                this.btnPresenca.text = 'SAIDA'
                this.loadCamera();
                this.$refs.presenca.open('');
            }
        }, (1 * 60000));
    },
    methods: {
        setIntervalo(agrupamento){
            const dateNow = new Date();
            let beginInterval  = new Date(agrupamento.intervalo_inicio)
            let finishInterval  = new Date(agrupamento.intervalo_fim)
            if(dateNow.getTime() > beginInterval.getTime() && dateNow.getTime() < finishInterval.getTime())
            {
                return true;
            }else
            {
                return false;
            }
        },
        setExit(finish){
            const dateNow = new Date();
            const finishTime = new Date(finish)
            // toletancia de 30 min após a aula
            const finishTolerance = new Date(finishTime)
            finishTolerance.setMinutes(finishTolerance.getMinutes() + 30);
            return dateNow.getTime() > finishTime.getTime() && dateNow.getTime() < finishTolerance.getTime()
            // if(dateNow.getTime() > finishTime.getTime() && dateNow.getTime() < finishTolerance.getTime())
            // {
            //     return true;
            // }else
            // {
            //     return false;
            // }
        },
        async registerFrequency(){
            this.loading = true

            if(this.photo == '')
            {
                this.$toasted.show('Foto necessária para presença!', {
                    position: 'top-right',
            });
                return
            }
            // fim
            let data = {
                entidade: localStorage.id_role == 4 ? 'ALUNO' : 'INSTRUTOR',
                id: localStorage.id,
                turma: this.agrupamento.id_turma_teorica,
                dispositivo: 'navegador'
            }
            await this.$http.post(urlApi + '/ead/presenca/novo', data).then(function (response) {
                if(this.setIntervalo(this.agrupamento))
                {
                    window.sessionStorage['intervalo'] = true;
                    this.$refs.presenca.close('');
                }
                if(this.setExit(this.agrupamento.data_fim))
                {
                    window.sessionStorage['saida'] = true;
                    this.$refs.presenca.close('');
                }
            }).catch(function (error) {
                console.log(error.body.mensagem)
                this.$toasted.show(error.body.mensagem, {
                    position: 'top-right',
                });
                console.log(error)
            })
            .finally(() => {
                this.loading = false
            })
        },
        loadCamera(){
            //Captura elemento de vídeo
            var video = document.querySelector("#webCamera");
            //As opções abaixo são necessárias para o funcionamento correto no iOS
            video.setAttribute('autoplay', '');
            video.setAttribute('muted', '');
            video.setAttribute('playsinline', '');
            if(navigator.mediaDevices.getUserMedia)
            {
            navigator.mediaDevices.getUserMedia({audio: false, video: {facingMode: 'user'}})
            .then( function(stream) {
                //Definir o elemento vídeo a carregar o capturado pela webcam
                video.srcObject = stream;
            })
            .catch(function(error) {
                alert("Acesso a câmera bloqueado");
            });
            }
        },
        self(){
            //Captura elemento de vídeo
            var video = document.querySelector("#webCamera");
            //Criando um canvas que vai guardar a imagem temporariamente
            var canvas = document.createElement('canvas');
            // canvas.width = 250;
            // canvas.height = 250;
            var ctx = canvas.getContext('2d');
            //Desenhando e convertendo as dimensões
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            //Criando o JPG
            var dataURI = canvas.toDataURL('image/jpeg'); //O resultado é um BASE64 de uma imagem.
            console.log(dataURI)
            document.querySelector("#self").setAttribute("src", dataURI);
            this.photo = dataURI;
        },
        clearPhoto(){
            document.getElementById('self').src = '';
        }
    },
}

</script>
